
import styles from './About.module.scss'
import React, {DetailedHTMLProps, HTMLAttributes, useState} from "react";
import {PageProps} from "@/types";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";


interface AboutProps extends  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  // person: Person
  title: string,
  text: string

}

export default function About({className, title, text}: AboutProps) {
  const [open, setOpen] = useState(false)

  return <div className={`${className} ${styles.about} ${open && styles.open}`}>
    <h2><a id={'about'}></a>{title}</h2>
    <div dangerouslySetInnerHTML={{__html: text}}></div>
    <button onClick={() => setOpen(!open)}>Lees {open ? 'minder' : 'meer'}</button>
  </div>
}
